import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './OrderDetailPage.css';

export default function OrderDetailPage() {
  const { id } = useParams();
  const [order, setOrder] = useState(null);
  const [images, setImages] = useState([]);
  const [folderOrderId, setFolderOrderId] = useState(null);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [pageImageUrls, setPageImageUrls] = useState(null);
  const [zipUrl, setZipUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchOrderInfo() {
      setLoading(true);
      try {
        const res = await fetch(`https://orders.fletaime.com/order-info/${id}`);
        const data = await res.json();
        setOrder(data.order || null);
        // Newer orders upload straight to Supabase Storage and record a full
        // public URL here instead of a bare local filename - only prefix
        // with our own /order_uploads/ path for the older, local-disk form.
        setImages((data.images || []).map(img =>
          /^https?:\/\//i.test(img) ? img : `https://orders.fletaime.com/order_uploads/${img}`
        ));
        setFolderOrderId(data.folderOrderId || null);
        setPdfUrl(data.pdfUrl || null);
        setPageImageUrls(data.pageImageUrls || null);
        setZipUrl(data.zipUrl || null);
      } catch {
        setOrder(null);
        setImages([]);
      }
      setLoading(false);
    }
    fetchOrderInfo();
  }, [id]);

  if (loading) return <div className="order-detail-page"><h2>Loading...</h2></div>;
  if (!order) return <div className="order-detail-page"><h2>Order not found</h2></div>;

  return (
    <div className="order-detail-page">
      <button className="back-btn" onClick={() => navigate('/dashboard')}>← Back to Dashboard</button>
      <div className="order-info">
        <h3>Order #{order.id}</h3>
        <div><b>Date:</b> {new Date(order.created_at).toLocaleString('sq-AL', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}</div>
        <div><b>Name:</b> {order.name}</div>
        <div><b>Last Name:</b> {order.last_name}</div>
        <div><b>Place:</b> {order.place}</div>
        <div><b>Address:</b> {order.address}</div>
        <div><b>Phone:</b> {order.phone}</div>
        <div><b>Comment:</b> {order.comment}</div>
        <div><b>Product Name:</b> {order.product_name}</div>
        <div><b>Price:</b> {order.price}</div>
        <div><b>Pages:</b> {order.pages}</div>
        <div>
          <b>Payment:</b>{' '}
          {order.payment_status === 'paid' ? (
            <span style={{ color: '#155724', background: '#d4edda', padding: '2px 8px', borderRadius: '4px', fontWeight: 'bold' }}>
              ✅ Paguar Online {order.amount_paid ? `(${order.amount_paid}€)` : ''}
            </span>
          ) : order.payment_method === 'card' ? (
            <span style={{ color: '#856404', background: '#fff3cd', padding: '2px 8px', borderRadius: '4px', fontWeight: 'bold' }}>
              ⏳ Në pritje të pagesës online
            </span>
          ) : (
            <span style={{ color: '#333', background: '#eee', padding: '2px 8px', borderRadius: '4px', fontWeight: 'bold' }}>
              Cash në Dorëzim
            </span>
          )}
        </div>
        {zipUrl ? (
          <div><b>Faqet e Librit:</b> <a href={zipUrl} target="_blank" rel="noopener noreferrer">Shkarko ZIP{pageImageUrls ? ` (${pageImageUrls.length} faqe)` : ''}</a></div>
        ) : pdfUrl ? (
          <div><b>PDF link:</b> <a href={pdfUrl} target="_blank" rel="noopener noreferrer">Open PDF</a></div>
        ) : (
          <div><b>PDF link:</b> <a href={`https://orders.fletaime.com/order_uploads/${id}.pdf`} target="_blank" rel="noopener noreferrer">Open PDF</a></div>
        )}
        {images.length > 0 && (
          <div><b>Fotot e Porosisë:</b> <a href={`https://orders.fletaime.com/order-images?id=${folderOrderId || id}`} target="_blank" rel="noopener noreferrer">Shiko Fotot ({images.length})</a></div>
        )}
      </div>
      <div className="slideshow">
        {images.length === 0 ? (
          <div>No images found for this order.</div>
        ) : (
          <div className="slides-wrapper">
            {images.map((img, idx) => (
              <img key={idx} src={img} alt={`Order ${order.id} - ${idx + 1}`} className="slide-img" />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
